import React from 'react';
import { siteContent } from '../mockData';
import { useTranslation } from 'react-i18next';

const MediaPartners = () => {
  const { mediaPartners } = siteContent;
  const { t } = useTranslation();

  return (
    <section id="media-partners" data-testid="media-partners-section" className="py-24 relative overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0D1F40] via-[#0A1628] to-[#0D1F40]"></div>
      
      {/* Animated Overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#00D4FF] rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#00E5A0] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 data-testid="media-partners-title" className="text-4xl md:text-5xl font-bold text-[#F5C518] mb-4">{t('mediaPartners.title')}</h2>
          <div className="w-32 h-1 bg-[#00E5A0] mx-auto"></div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {mediaPartners.map((partner, index) => (
            <div
              key={index}
              className="bg-[#1a2942]/30 backdrop-blur-sm p-8 rounded-lg border border-[#00D4FF]/20 hover:border-[#00E5A0]/60 transition-all duration-300 flex items-center justify-center hover:transform hover:scale-110 hover:shadow-xl group min-h-[120px]"
            >
              {partner.logo ? (
                <img 
                  src={partner.logo} 
                  alt={partner.name}
                  className="max-w-full max-h-[80px] w-auto h-auto object-contain filter brightness-90 group-hover:brightness-110 transition-all"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const fallback = e.target.parentElement.querySelector('.fallback-text');
                    if (fallback) fallback.style.display = 'block';
                  }}
                />
              ) : null}
              <div className="fallback-text text-white text-center font-bold text-lg opacity-70 group-hover:opacity-100 transition-opacity" style={{ display: partner.logo ? 'none' : 'block' }}>
                {partner.name}
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden relative overflow-hidden">
          <div className="flex animate-scroll space-x-6">
            {[...mediaPartners, ...mediaPartners].map((partner, index) => (
              <div
                key={index}
                className="flex-shrink-0 bg-[#1a2942]/30 backdrop-blur-sm p-6 rounded-lg border border-[#00D4FF]/20 w-48 h-32 flex items-center justify-center"
              >
                {partner.logo ? (
                  <img 
                    src={partner.logo} 
                    alt={partner.name}
                    className="max-w-full max-h-[60px] w-auto h-auto object-contain filter brightness-90"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const fallback = e.target.parentElement.querySelector('.fallback-text');
                      if (fallback) fallback.style.display = 'block';
                    }}
                  />
                ) : null}
                <div className="fallback-text text-white text-center font-bold opacity-70" style={{ display: partner.logo ? 'none' : 'block' }}>
                  {partner.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
      `}</style>
    </section>);

};

export default MediaPartners;